import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
document.title = 'New Tab // Pound'
ReactDOM.render(<App />, document.getElementById('root'))
